import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentRadarItem } from './ContentRadarItem'
import { Card } from '@/components/ui/card'
import { EContentRadar } from '@/store/api/Person/Person.types'

interface ContentRadarWidgetTypes {
  contentRadar?: EContentRadar
}

export const ContentRadarWidget = ({
  contentRadar,
}: ContentRadarWidgetTypes) => {
  const { t } = useTranslation()
  return (
    <Card className="bg-baseColor rounded-2xl p-4 flex flex-col gap-4">
      <div className="flex flex-col gap-1 justify-center">
        <p className="text-neutralColor text-xl font-medium">
          {t('report.generalInfo.contentRadar')}
        </p>
        <p className="text-xs font-medium text-neutralColor60">
          {contentRadar === EContentRadar.LOW &&
            t('report.generalInfo.minimalOrNoInteraction')}
          {contentRadar === EContentRadar.MEDIUM &&
            t('report.generalInfo.occasionalInteraction')}
          {contentRadar === EContentRadar.HIGH &&
            t('report.generalInfo.significantOrImpactfulInteraction')}
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-5">
          <ContentRadarItem
            isActive={contentRadar === EContentRadar.LOW}
            value={contentRadar}
            title={t('report.generalInfo.clean')}
          />
          <ContentRadarItem
            isActive={contentRadar === EContentRadar.MEDIUM}
            value={contentRadar}
            title={t('report.generalInfo.notable')}
          />
          <ContentRadarItem
            isActive={contentRadar === EContentRadar.HIGH}
            value={contentRadar}
            title={t('report.generalInfo.concerning')}
          />
        </div>
      </div>
    </Card>
  )
}
